import { createRepository } from './Repository'

export interface CreateTicketRequest {
  text: string;
}

const repository = createRepository({
  basePath: '/api',
  useAuth: true
})

export const TicketRepository = {
  createTicket: (body: CreateTicketRequest) => {
    return repository.post<any, CreateTicketRequest>('/create_ticket', body)
  }
}
